import React, { memo } from 'react'
import PropTypes from 'prop-types'

import {
  MapPinPopover,
  MapPinPopoverDescription,
  MapPinPopoverTitle,
} from '../../styled'

import MapPin from './map-pin'

const LocationMapPin = ({ index, title, description, disabled }) => (
  <MapPin type={disabled ? 'locationDisabled' : 'location'} text={index}>
    <MapPinPopover>
      <MapPinPopoverTitle>{title}</MapPinPopoverTitle>
      <MapPinPopoverDescription>{description}</MapPinPopoverDescription>
    </MapPinPopover>
  </MapPin>
)

LocationMapPin.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  disabled: PropTypes.bool,
}

LocationMapPin.defaultProps = {
  description: '',
  disabled: false,
}

export default memo(LocationMapPin)
